import { render, staticRenderFns } from "./LineSeparateResize.vue?vue&type=template&id=a4065578&"
import script from "./LineSeparateResize.vue?vue&type=script&lang=js&"
export * from "./LineSeparateResize.vue?vue&type=script&lang=js&"
import style0 from "./LineSeparateResize.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports